import { createStore } from 'redux';

let Store = {},
    _state = {
        countries: {},
        submitData: {}
    };

let stateHandler = (state, action) => {
    switch (action.type) {
        case 'UPDATE':
            Object.assign(_state, action.data);
            return _state;
        case 'INIT':
            _state = state;
            return _state;
            break;
        default:
            return _state;
            break;
    };
};

Store = createStore(stateHandler);

window.Store = Store;

export default Store;



// WEBPACK FOOTER //
// ./src/familyshield/js/store.js